import { Contract, ContractTenant } from '../../../../../../common/validations'
import { isSuggestionDisabled } from './isSuggestionDisabled'
import { isTerminationDisallowedBecauseOfPending } from '../../../../ContractChanges/utils/isTerminationDisallowedBecauseOfPending'

import { useTerminateSuggestions } from 'views/ContractChanges/hooks/useTerminateSuggestions'
import { useTerminatePendingSuggestion } from 'views/TerminateContract/hooks/useTerminatePendingSuggestion'
import { useModuleConfig } from 'hooks/useModuleConfig/useModuleConfig'

export const useSuggestions = (contract: Contract) => {
  const { terminateSuggestions } = useTerminateSuggestions()
  const { terminatePendingSuggestion } = useTerminatePendingSuggestion()
  const { contractModification } = useModuleConfig()
  const terminationDisallowedBecauseOfPending =
    isTerminationDisallowedBecauseOfPending(contract)

  const getSuggestions = (
    tenant: ContractTenant,
    terminateTenantIds: number[]
  ) => {
    if (terminationDisallowedBecauseOfPending) {
      return [terminatePendingSuggestion]
    }

    return terminateSuggestions.map((suggestion) => ({
      ...suggestion,
      disabled: isSuggestionDisabled({
        suggestion,
        contract,
        tenant,
        terminateTenantIds,
        contractModification,
      }),
    }))
  }

  return {
    getSuggestions,
  }
}
